<template>
  <div>
    <Inventory_report_list/>
  </div>
</template>

<script>
import Inventory_report_list from "@/components/adminArin/pos_system/warehouse/inventoryreport/Inventory_report_list";
export default {
  name: "inventoryreportlist",
  components: {
    Inventory_report_list
  }
}
</script>

<style scoped>

</style>
